module.exports = __webpack_public_path__ + "static/media/wallet-effect.d17440db.mp3";